import * as React from "react"
import styles from "./activitySelection/ActivitySelection.module.scss";
import ActivityItem from "./activitySelection/ActivityItem";
import Button from "../../../../Componnets/mainButton/Button";
import {useEffect} from "react";
import appContext from "../../../../../context/appContext";
import http from "../../../../../services/api/utilities/http";

const ActivitySelection = (props) => {
  const [variantsList, setVariantsList] = React.useState([])

  const newData = {
    logic: props.selectedItems?.length > 0 ? "AND" : undefined,
    operand: undefined,
    value: [],
  }

  const context = React.useContext(appContext)

  const getData = () => {
    let uid = null;
    if (context.handleUid().uid) {
      uid = context.handleUid().uid;
    } else {
      uid = JSON.parse(localStorage.getItem("mapData")).uid;
    }

    http.get('process_mining/process_discovery/' + uid)
      .then(res => {
        setVariantsList(res.data.data.nodes.map(item => item.name));
      })
      .catch(err=>{
        console.log(err.response)
      })
  }

  useEffect(() => {
    getData()
    if (!props.selectedItems?.operand && !props.selectedItems?.value) {
      props.onChangeFilter(newData)
    }
  }, [])

  const handleChangeProperties = (dataIndex, value) => {
    const passedFilter = {
      ...value,
      value: value.value,
      operand: value.value?.length ? value.value?.map(item => value.operand?.[0]) : value.operand,
      is_active: true
    }
    props.onChangeFilter(passedFilter)
    // const copyData = [...data]
    // const findIndex = copyData.findIndex((item, index) => dataIndex === `${item.rule || "rule"}_${index}`)
    // copyData.splice(findIndex, 1, value)
    // setData(copyData)
    // props.onChangeFilter(copyData)
  }

  return (
    <>
      <div className={styles.ActivitySelection}>
        <div className={styles.title}>
          <div>Activity Selection</div>
          <div>Set rules for including or not including an activity in your filters.</div>
        </div>
        <div className={styles.mainContentTitle}>
          Give me all cases that:
        </div>
        {/*{*/}
        {/*  data.map((item, index) => <ActivityItem key={`${item.rule || "rule"}_${index}`} index={`${item.rule || "rule"}_${index}`} data={item} onChangeProperties={handleChangeProperties} />)*/}
        {/*}*/}
        {
          <ActivityItem index={`${props.selectedItems?.operand || "operand"}_1`} data={props.selectedItems || []} onChangeProperties={handleChangeProperties} variantsList={variantsList} />
        }
        <div className={'mt-4'} style={{pointerEvents: "none", opacity: 0.3}}>
          <Button type={"outlined"} color={"primary"} size={"small"} leftIcon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0003 6.93945V13.0447" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.0554 9.99215H6.94434" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M13.9051 1.66675H6.09556C3.37334 1.66675 1.66699 3.59348 1.66699 6.32105V13.6791C1.66699 16.4067 3.3654 18.3334 6.09556 18.3334H13.9051C16.6352 18.3334 18.3337 16.4067 18.3337 13.6791V6.32105C18.3337 3.59348 16.6352 1.66675 13.9051 1.66675Z" stroke="#8A0FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>}>
            Add Another Rule
          </Button>
        </div>
      </div>
    </>
  )
}

export default ActivitySelection